import { z } from 'zod';

import { parseDto } from '../../mappers/parseDto';
import type { Transport } from '../../transport/Transport';

const responseDto = z.object({
  data: z.record(z.record(z.record(z.string()))),
});

export type StorefrontTranslations = Record<string, Record<string, Record<string, string>>>;

export interface TranslationService {
  list(signal?: AbortSignal): Promise<StorefrontTranslations>;
}

export function createLaravelTranslationService(transport: Transport): TranslationService {
  return {
    async list(signal) {
      const response = await transport.request({
        method: 'GET',
        path: '/storefront/translations',
        ...(signal ? { signal } : {}),
      });
      return parseDto(responseDto, response.data, 'GET /storefront/translations').data;
    },
  };
}
